import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { UserRole } from '../../types';

const PublicOnly: React.FC = () => {
  const accessToken = useAuthStore((s) => s.accessToken);
  const userRole = useAuthStore((s) => s.user?.role);

  if (accessToken) {
    const home =
      userRole === UserRole.SUPER_ADMIN ? '/tenants' :
      userRole === UserRole.GROUP_ADMIN ? '/group-admin' :
      '/dashboard';
    return <Navigate to={home} replace />;
  }

  return <Outlet />;
};

export default PublicOnly;
